import { render, staticRenderFns } from "./password-new.vue?vue&type=template&id=5aca0c0d"
import script from "./password-new.vue?vue&type=script&lang=js"
export * from "./password-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports